import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { IconButton } from 'seagull';
import { Box } from 'seagull/components/Layout';
import { Bell } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useEventReporter } from '~/event-reporter';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
import { useStore, useStoreActions } from '~/store/store-context';
import styles from './InAppNotificationsButton.module.scss';
export const NOTIFICATIONS_TRIGGER_SPOTLIGHT_ID = 'notifications-drawer-trigger-spotlight';
const deprecatedTestIds = {
    /**
     * @deprecated - don't add new key here!!!!
     */ InAppNotificationsButtonTestIds: {
        Root: 'home-sidebar-notification-center',
        Pimple: 'home-sidebar-notification-center-pimple'
    }
};
export const GetInAppNotificationsButtonTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds
    });
export function InAppNotificationsButton() {
    const { setInAppNotificationsDrawerOpen, logBI } = useStoreActions();
    const showNotificationPimple = useStore((state)=>state.showNotificationPimple);
    const inAppNotificationsDrawerOpen = useStore((state)=>state.inAppNotificationsDrawerOpen);
    const email = useStore(selectors.user.email);
    const { reportToHeap } = useEventReporter();
    const { InAppNotificationsButtonTestIds } = useMemo(()=>GetInAppNotificationsButtonTID(), []);
    const { t: drawerTexts } = useLocaleKeys('notification.drawer');
    const handleClick = ()=>{
        logBI(15000);
        reportToHeap('sidebar', 'click', 'vendor-clicked-notifications-btn', {
            email
        });
        setInAppNotificationsDrawerOpen(!inAppNotificationsDrawerOpen);
    };
    return /*#__PURE__*/ _jsxs(Box, {
        className: styles.root,
        alignItems: "center",
        testId: InAppNotificationsButtonTestIds.Container(),
        children: [
            /*#__PURE__*/ _jsx(IconButton, {
                id: NOTIFICATIONS_TRIGGER_SPOTLIGHT_ID,
                bi: {
                    name: inAppNotificationsDrawerOpen ? 'in_app_notifications_close' : 'in_app_notifications_open'
                },
                tooltip: {
                    title: drawerTexts.title()
                },
                skin: "transparent",
                aspect: "square",
                size: "smallMedium",
                noPadding: true,
                testId: InAppNotificationsButtonTestIds.Root(),
                onClick: handleClick,
                children: /*#__PURE__*/ _jsx(Bell, {})
            }),
            showNotificationPimple && /*#__PURE__*/ _jsx(Box, {
                className: styles.pimple,
                testId: InAppNotificationsButtonTestIds.Pimple()
            })
        ]
    });
}
